import { useRouter } from 'next/router';
import { ReactElement } from 'react';

import { IHome } from '@/modules/home/types';
import { Typography } from '@/shared/components/atoms';
import Badges from '@/shared/components/atoms/Badges';
import { EntityType } from '@/shared/constant/enums';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { getLocalizedDate } from '@/shared/lib/dates';

interface IProps {
  name: string;
  createdBy: string;
  plots: IHome.IPlotItem[];
  timestamp: string;
  // status: IHome.ITaskStatus;
}
const TaskHeader = ({
  createdBy,
  name,
  plots,
  // status,
  timestamp,
}: IProps): ReactElement => {
  const { locale } = useRouter();

  const [selectedAsset] = useStore((store) => store?.asset);

  return (
    <>
      {/* task name  */}
      <div className='flex items-center justify-between gap-8 '>
        <Typography variant='subtitle2' weight='semiBold' className=''>
          {name}
        </Typography>
        <Typography
          variant='caption'
          className=' whitespace-nowrap text-surface-10'
        >
          {getLocalizedDate({
            date: timestamp,
            formatDate: 'hh:mm a',
            locale,
          })}
        </Typography>
      </div>
      {/* task Creator */}
      <div className='flex items-center gap-8'>
        <Typography
          variant='subtitle2'
          weight='medium'
          className='text-surface-10'
        >
          {createdBy}
        </Typography>
        <div>
          <Badges
            className=' border-xs  !border-neutralVariant-90 bg-white '
            badgesList={plots}
            show={2}
            getLabel={(job) => job.name}
            getImage={
              selectedAsset?.entityTypeId === EntityType.FARM
                ? (job) => job.cropImage
                : undefined
            }
          />
        </div>
      </div>
    </>
  );
};
export { TaskHeader };
